import Vue from 'vue';
import moment from 'moment';
import VS2 from 'vue-script2';
import Quasar, {
    QAutocomplete,
    QBtn,
    QCard,
    QCarousel,
    QCarouselSlide,
    QCheckbox,
    QChip,
    QDialog,
    QInput,
    QInputFrame,
    QItem,
    QItemMain,
    QItemSide,
    QItemTile,
    QLayout,
    QLayoutDrawer,
    QLayoutFooter,
    QLayoutHeader,
    QList,
    QModal,
    QModalLayout,
    QPage,
    QPageContainer,
    QPopover,
    QRadio,
    QRange,
    QSelect,
    QSpinner,
    QTab,
    QTabPane,
    QTabs,
    QToggle,
    QToolbar,
    QToolbarTitle,
    QTooltip,
    QCollapsible,
    Notify
} from 'quasar-framework/dist/quasar.mat.esm';
import Vuelidate from 'vuelidate';
import { G2S } from 'core/g2s';
import * as api from 'core/api';
import store from './store';
import router from './router';
import * as utils from 'core/utils';
import { ContentModalComponent } from './components/content/modal';
import { ContentTextComponent } from './components/content/text';
import { CustomDialogComponent } from './components/custom-dialog';
import { DialogCatchUpComponent } from './components/dialog-catch-up';
import { DialogAppComponent } from './components/dialog-app';
import { DrawerMenuComponent } from './components/navigation/drawer-menu';
import { FlightCardComponent } from './components/flight/card';
import { FullScreenDialogComponent } from './components/full-screen-dialog';
import { RegionSelectorComponent } from './components/header-region-selector';
import { SwitchLanguageComponent } from './components/language-switcher';
import { FlightDetailsComponent } from './components/flight/details';
import { FlightSearchFormComponent } from './components/flight/search-form';
import { FlightTermsComponent } from './components/flight/terms';
import { SearchTabsComponent } from './components/flight/search-tabs';
import { MobileInputComponent } from './components/forms/mobile-input';
import { PaymentFormComponent } from './components/payment/form';
import { ProductListComponent } from './components/product/list';
import { SeatsSelectionComponent } from './components/flight/seats-selection';
import { ProductNotPackageComponent } from './components/product/not-package';
import { ProductPackageComponent } from './components/product/package';
import { OnlineRegistrationComponent } from './components/product/online-registration';
import { ProductServiceBrandComponent } from './components/product/service-brands';
import { AdvancedProductServiceBrandComponent } from './components/product/advanced-service-brands';
import { ProductTimerComponent } from './components/product/timer';
import { AdditionalBaggageComponent } from './components/flight/additional-baggage';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

G2S.init();

// axios global interceptor for required sign in
G2S.$http.interceptors.response.use((response) => {
    return response;
}, function (error) {
    if (error.response && (error.response.status == 401 || error.response.status == 403)) {
        (<any>Vue).prototype.$auth.signOutClientSide();

        // Redirect only for /account routes!!!
        if (router.currentRoute && utils.String.startsWith(router.currentRoute.path, '/account')) {
            router.push({
                path: '/signin',
                query: (router.currentRoute ? { redirect: router.currentRoute.fullPath } : {})
            });
        }
    }
    return Promise.reject(error);
});

Vue.use(<any>Vuelidate);
Vue.use(<any>VS2);
Vue.use(Quasar, {
    components: {
        QAutocomplete,
        QBtn,
        QCard,
        QCarousel,
        QCarouselSlide,
        QCheckbox,
        QChip,
        QDialog,
        QInput,
        QInputFrame,
        QItem,
        QItemMain,
        QItemSide,
        QItemTile,
        QLayout,
        QLayoutDrawer,
        QLayoutFooter,
        QLayoutHeader,
        QList,
        QModal,
        QModalLayout,
        QPage,
        QPageContainer,
        QPopover,
        QRadio,
        QRange,
        QSelect,
        QSpinner,
        QTab,
        QTabPane,
        QTabs,
        QToggle,
        QToolbar,
        QToolbarTitle,
        QTooltip,
        QCollapsible
    },
    plugins: { Notify },
    loadingBar: {
        skipHijack: true // disabled loading for webvizor
    }
});

Vue.component('content-modal', ContentModalComponent);
Vue.component('content-text', ContentTextComponent);
Vue.component('custom-dialog', CustomDialogComponent);
Vue.component('dialog-catch-up', DialogCatchUpComponent);
Vue.component('full-screen-dialog', FullScreenDialogComponent);
Vue.component('dialog-app', DialogAppComponent);
Vue.component('drawer-menu', DrawerMenuComponent);
Vue.component('flight-card', FlightCardComponent);
Vue.component('flight-details', FlightDetailsComponent);
Vue.component('flight-search-form', FlightSearchFormComponent);
Vue.component('region-selector', RegionSelectorComponent);
Vue.component('language-switcher', SwitchLanguageComponent);
Vue.component('flight-terms', FlightTermsComponent);
Vue.component('search-tabs', SearchTabsComponent);
Vue.component('mobile-input', MobileInputComponent);
Vue.component('payment-form', PaymentFormComponent);
Vue.component('product-list', ProductListComponent);
Vue.component('seats-selection', SeatsSelectionComponent);
Vue.component('product-not-package', ProductNotPackageComponent);
Vue.component('product-package', ProductPackageComponent);
Vue.component('product-registration', OnlineRegistrationComponent);
Vue.component('product-service-brand', ProductServiceBrandComponent);
Vue.component('advanced-product-service-brand', AdvancedProductServiceBrandComponent);
Vue.component('product-timer', ProductTimerComponent);
Vue.component('additional-baggage', AdditionalBaggageComponent);

(<any>Vue).prototype.$getClientDevice = function (): api.ClientDevice {
    const result = {
        browser: (<any>this).$q.platform.is.name || G2S.config.clientDevice.browser,
        colorDepth: screen.colorDepth,
        ipAddress: G2S.config.clientDevice.ipAddress,
        javaEnabled: true,
        language: navigator.language,
        platform: (<any>this).$q.platform.is.platform || G2S.config.clientDevice.platform,
        screenHeight: screen.height,
        screenWidth: screen.width,
        timezone: new Date().getTimezoneOffset(),
        type: G2S.config.clientDevice.type,
        userAgent: navigator.userAgent,
        windowHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        windowWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    };

    if (result.platform.length > 10) {
        result.platform.length = result.platform.substring(0, 10);
    }

    if (result.browser.length > 20) {
        result.browser.length = result.browser.substring(0, 20);
    }

    if ((<any>this).$q.platform.is.mobile) {
        result.type = 'mobile';
    }
    
    if ((<any>this).$q.platform.is.platform === 'mac') {
        result.platform = 'macos';
    }

    switch (G2S.config.clientDevice.browser) {
        case 'app_android':
            result.browser = 'app_android';
            break;

        case 'app_iphone':
            result.browser = 'app_iphone';
            break;
    }

    switch (G2S.config.clientDevice.platform) {
        case 'android':
            result.platform = 'android';
            break;

        case 'iphone':
            result.platform = 'iphone';
            break;
    }

    return result;
};

// GA support
// https://groups.google.com/forum/#!searchin/phonegap/google$20analytics/phonegap/Mtj6KoUk8cY/1oPJ-UEhpBIJ

const root = new Vue(WithRender({
    el: '#q-app',
    store,
    router,
    data: () => {
        return {
            // v-model value for left drawer
            drawerLeftState: true
        };
    }
}));

window['ROOT'] = root;
window['moment'] = moment;
